import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minWidth: "auto",
    width: "fit-content",
    backgroundColor: "transparent",
  },
  select: {
    height: "32px",
    minHeight: "32px",
    width: "auto",
    borderRadius: "9999px",
    overflow: "hidden",
    backgroundColor: `${theme.palette.background.paper} !important`,
    color: theme.palette.primary.main,
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: "1px",
      borderRadius: "9999px",
    },
    "&:hover": {
      backgroundColor: `${theme.palette.background.paper} !important`,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
    "&.Mui-focused": {
      backgroundColor: `${theme.palette.background.paper} !important`,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
      borderWidth: "1px",
    },
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      height: "32px !important",
      minHeight: "32px !important",
      boxSizing: "border-box",
      padding: "6px 12px !important",
      backgroundColor: "transparent !important",
    },
  },
  selectValue: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    width: "100%",
    height: "32px",
    direction: "rtl",
    color: theme.palette.primary.main,
  },
  filterIcon: {
    width: "20px",
    height: "20px",
    flexShrink: 0,
  },
  selectText: {
    flex: 1,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "140%",
    whiteSpace: "nowrap",
    textAlign: "right",
  },
  selectChevron: {
    fontSize: "20px !important",
    color: theme.palette.primary.main,
    flexShrink: 0,
  },
}));
